import { useFetchMixAPi1 } from "hooks";
import { getURLWithParams } from "utils/context";

export const useProdutosList = (params = {}) =>
  useFetchMixAPi1(getURLWithParams("/legislacao/produtos", params));
